import React from 'react';
import { setCurrentView } from 'core/utils';
import { UpdateInventoryLogViewStore } from 'modules/product/stores';
import { UpdateInventoryLogTemplate } from 'themes/modules/product/pages';

@setCurrentView(
	(rootStore, componentProps) => new UpdateInventoryLogViewStore(rootStore, componentProps),
	'updateInventoryLogViewStore'
)
class UpdateInventoryLog extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <UpdateInventoryLogTemplate {...this.props} viewStore={this.props.updateInventoryLogViewStore} />;
	}
}

export default UpdateInventoryLog;



// WEBPACK FOOTER //
// ./src/modules/product/pages/UpdateInventoryLog.jsx